import React from "react";
import { ActionCell, NumberCell, TextCell } from "./CalculatieSectionTable";
import CalculatieSectionTable from "./CalculatieSectionTable";
import { computeSectionTotals, toMoney } from "./utils";
import PricingSourceBadge from "./PricingSourceBadge";
import { formatPricingDate } from "../../utils/pricingUi";

export default function CalculatieLaborSection({
  lines,
  hourTypes,
  open,
  onToggle,
  onChange,
  onHourTypeChange,
  onAdd,
  onRemove,
  showFinancials = true,
  onOpenPricingDetail,
}) {
  const columns = [
    { key: "hourType", label: "Uursoort", headerClassName: "text-left w-[160px]" },
    { key: "description", label: "Omschrijving", headerClassName: "text-left min-w-[260px]" },
    { key: "quantity", label: "Uren", headerClassName: "text-right w-[100px]", cellClassName: "w-[100px]" },
    { key: "unit", label: "Eh", headerClassName: "text-left w-[80px]", cellClassName: "w-[80px]" },
    { key: "sellRate", label: "Verkoop/u", headerClassName: "text-right w-[120px]", cellClassName: "w-[120px]" },
    ...(showFinancials
      ? [{ key: "costRate", label: "Kost/u", headerClassName: "text-right w-[120px]", cellClassName: "w-[120px]" }]
      : []),
    { key: "pricingSource", label: "Prijsbron", headerClassName: "text-left w-[170px]", cellClassName: "w-[170px]" },
    { key: "totalSell", label: "Verkoop totaal", headerClassName: "text-right w-[140px]", cellClassName: "text-right w-[140px]" },
    ...(showFinancials
      ? [
          { key: "totalCost", label: "Kost totaal", headerClassName: "text-right w-[130px]", cellClassName: "text-right w-[130px]" },
          { key: "margin", label: "Marge", headerClassName: "text-right w-[120px]", cellClassName: "text-right w-[120px]" },
        ]
      : []),
    { key: "action", label: "", headerClassName: "text-right w-[60px]", cellClassName: "text-right w-[60px]" },
  ];
  const rows = lines.map((line, index) => {
    const quantity = Number(line.quantity || 0);
    const costRate = Number(line.costRate || 0);
    const sellRate = Number(line.sellRate || 0);
    const totalCost = quantity * costRate;
    const totalSell = quantity * sellRate;
    const margin = totalSell - totalCost;

    return {
      key: `labor-${index}`,
      cells: {
        hourType: (
          <select
            value={line.hourTypeId || ""}
            onChange={(e) => onHourTypeChange(index, e.target.value)}
            className="w-full rounded-sm border border-slate-200 bg-white px-2 py-1.5 text-sm text-slate-900 outline-none transition focus:border-slate-400"
          >
            <option value="">Kies uursoort</option>
            {hourTypes.map((item) => (
              <option key={item._id} value={item._id}>
                {item.code ? `${item.code} - ${item.name}` : item.name}
              </option>
            ))}
          </select>
        ),
        description: (
          <TextCell
            value={line.description}
            onChange={(e) => onChange(index, "description", e.target.value)}
            placeholder="Omschrijving van werkzaamheden"
          />
        ),
        quantity: (
          <NumberCell
            value={line.quantity}
            onChange={(e) => onChange(index, "quantity", e.target.value)}
            placeholder="0"
          />
        ),
        unit: (
          <TextCell value={line.unit} onChange={(e) => onChange(index, "unit", e.target.value)} placeholder="uur" />
        ),
        costRate: (
          <NumberCell
            value={line.costRate}
            onChange={(e) => onChange(index, "costRate", e.target.value)}
          />
        ),
        sellRate: (
          <NumberCell
            value={line.sellRate}
            onChange={(e) => onChange(index, "sellRate", e.target.value)}
          />
        ),
        pricingSource: (
          <div className="space-y-1">
            <PricingSourceBadge snapshot={line.pricingSnapshot} />
            <div className="text-[11px] text-slate-500">{formatPricingDate(line?.pricingSnapshot?.pricingDate)}</div>
            {onOpenPricingDetail ? (
              <button
                type="button"
                onClick={() => onOpenPricingDetail({ lineType: "labor", line, index })}
                className="text-[11px] font-medium text-slate-600 underline-offset-2 hover:text-slate-900 hover:underline"
              >
                Broninfo
              </button>
            ) : null}
          </div>
        ),
        totalCost: <span className="font-medium text-slate-900">€ {toMoney(totalCost)}</span>,
        totalSell: <span className="font-medium text-slate-900">€ {toMoney(totalSell)}</span>,
        margin: (
          <span className={`font-medium ${margin < 0 ? "text-rose-700" : "text-emerald-700"}`}>
            € {toMoney(margin)}
          </span>
        ),
        action: <ActionCell onRemove={() => onRemove(index)} />,
      },
    };
  });

  return (
    <CalculatieSectionTable
      title="Arbeid"
      description="Urenregels, interne kost en verkoop direct naast elkaar voor snelle controle."
      open={open}
      onToggle={onToggle}
      columns={columns}
      rows={rows}
      subtotal={computeSectionTotals(lines)}
      onAdd={onAdd}
      emptyState="Nog geen arbeidregels toegevoegd."
    />
  );
}
